import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { CallMonitorProvider } from "./contexts/CallMonitorContext";
import { initializeSentry } from "./lib/sentry";

// Initialize error tracking
initializeSentry();

// Global error handlers
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

createRoot(document.getElementById("root")!).render(
  <CallMonitorProvider>
    <App />
  </CallMonitorProvider>
);
